import { Component, OnInit, ViewChild } from '@angular/core';
import { Program } from '../../programs/shared/program.model';
import { ProgramsComponent } from '../../programs/programs.component';
import { StudentService } from '../shared/student.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-student-programs',
  templateUrl: './student-programs.component.html',
  styleUrls: ['./student-programs.component.scss']
})
export class StudentProgramsComponent implements OnInit {

  programs: Program[];
  showError = false;
  messageError: String = '';

  @ViewChild(ProgramsComponent)
  programsComponent: ProgramsComponent;

  constructor(private studentService: StudentService, private router: Router) { }

  ngOnInit() {
    const cedula = localStorage.getItem('cedula');
    this.studentService.getProgramsByStudent(cedula, null).subscribe((result) => {
      if (result.data !== []) {
        this.programs = result.data;
      }
    },
    (error) => {
        console.log(error);
    });
  }

  sendProgramSelected() {
    const selectProgram =  this.programsComponent.selectedProgram;
    if (selectProgram === undefined) {
      this.showError = true;
      this.messageError = 'Debe seleccionar alguno de los programas.';
    } else {
      this.showError = false;
      this.messageError = '';
      this.router.navigate(['solicitudes/tipo-disponibles'] ,
      { queryParams: { programa: selectProgram.codigo , version: selectProgram.version } });
    }
  }

}
